module.exports = __webpack_public_path__ + "40e445210c24b1f233564224ab2a1d02.png";